import { REQUEST } from '@/constants/api';

import { TaxInfoEntry, TaxInfoRequestPayload } from '@/types/api/tax-info';

import { axios } from './axios';

export const getTaxInfo = async () => {
  const result = await axios.get<TaxInfoEntry[]>(REQUEST.TAX_INFO.ROOT);

  return result.data ?? [];
};

export const createTaxInfo = async (payload: TaxInfoRequestPayload) => {
  const result = await axios.post<TaxInfoRequestPayload>(
    REQUEST.TAX_INFO.ROOT,
    payload,
  );

  return result.data;
};

export const updateTaxInfo = async (payload: TaxInfoRequestPayload) => {
  const result = await axios.put<TaxInfoRequestPayload>(
    REQUEST.TAX_INFO.ROOT,
    payload,
  );

  return result.data;
};
